var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.358,
    height: 60.358,
    viewBox: "0 0 60.358 60.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M33.554,3.375A30.179,30.179,0,1,0,63.733,33.554,30.175,30.175,0,0,0,33.554,3.375ZM49.007,25.211,29.608,44.7h-.015a2.62,2.62,0,0,1-1.683.8,2.54,2.54,0,0,1-1.7-.827l-8.125-8.125a.578.578,0,0,1,0-.827l2.583-2.583a.561.561,0,0,1,.813,0l6.442,6.442,17.7-17.832a.573.573,0,0,1,.406-.174h0a.527.527,0,0,1,.406.174l2.539,2.626A.572.572,0,0,1,49.007,25.211Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#32d172"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f40d4c1ca7668f0a132f8e7c28009e00.svg";
export { ForwardRef as ReactComponent };